<template>
  <v-ons-page>

    <v-ons-modal :visible="true">
      <div class="header">
        <img src="../../assets/lasmeru-logo-bold.png">
      </div>
      <p style="text-align: center; text-size: 0.8em;">
        ご不便をおかけして申し訳ございません。 
      </p>
      <!-- 更新ボタンを出せないか？ -->
      <p style="text-align: center; text-size: 0.8em;">
        {{message[errIndex]}}
      </p>
    </v-ons-modal>

  </v-ons-page>
</template>

<script>
// import firebase from 'firebase'
import common from '../../util/common'

export default {
  name: 'ErrorSuspend',
  mixins: [common],
  data () {
    return {
      errIndex: 0,
      message: [
        'メンテ中ですので、しばらく時間をあけてみてください。',
        'アプリのバージョンアップが必要です！'
      ]
    }
  },

  created () {
    this.errIndex = this.$route.params.errIndex
  },

  computed: {
  },

  watch: {
  },

  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../src/assets/css/miley.css";
</style>



// WEBPACK FOOTER //
// src/components/CommonChildren/ErrorSuspend.vue